<template>
  <div>
    <div v-if='hasParents'>
      <component :is='renderers[parentComponent.type]'
                 :transform='transform'
                 :parent-transform='directParent'
                 :transforms-and-source='transformsAndSource'
                 :partutil='partutil' />
    </div>
    <div class="flex flex-col h-40">
      <quick-transform-edit-components :transform='transform'
                     :partutil='partutil'
                     :treeutil='treeutil'
                     :transforms-and-source='transformsAndSource'
                     :selections-data='selectionsData'
                     class='h-32 quick-edit-components'
                     @add-component='$emit("add-component", $event)'
                     @change-component='$emit("change-component")'
                     @preview='$emit("preview", $event)'
                     />
      <!--
      <component-graph-renderer :transform='transform'
                     :partutil='partutil' 
                     :treeutil='treeutil'
                     :transforms-and-source='transformsAndSource'  />
      -->
        <!--
      <quick-animate :transform='transform'
                     :partutil='partutil' 
                     :transforms-and-source='transformsAndSource' />
        -->
    </div>
      <!--
    <div class="flex flex-row justify-center my-1">
      <pbc-toggle-button>
        Delay
      </pbc-toggle-button>
      <pbc-toggle-button v-model='animationMode'>
        Animations
      </pbc-toggle-button>
      <pbc-toggle-button v-model='animationMode'>
        Movement
      </pbc-toggle-button>
      <pbc-toggle-button>
        Move
      </pbc-toggle-button>
    </div>
      -->
  </div>
</template>
<script>
import Treeutil from '@edit/tree/treeutil.js';
//import ComponentGraphRenderer from '@edit/organisms/ComponentGraphRenderer.vue';
import QuickTransformEditComponents from '@edit/organisms/QuickTransformEditComponents.vue';
import QuickAnimate from '@ui/organisms/QuickAnimate.vue';

import DelayOverlay from '@ui/molecules/DelayOverlay';
export default {
  props: {
    transform:{
      type: Object,
      required: true
    },
    partutil:{
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    selectionsData: {
      type: Array,
      required: true
    }
  },
  data() {
    const component = this.partutil.findComponentForTransform(this.transform);
    const {components, links} = this.partutil.findComponentsAndLinksFrom(component);
    const treeutil = new Treeutil({
      components,
      links
    });

    const parents = this.partutil.getParentsForTransform(this.transform);
    let parentComponent;
    if (parents.length) {
      parentComponent = this.partutil.findComponentForTransform(parents[0]);
    }

    const renderers = {
      delayTransform: DelayOverlay
    }
    return {
      parents,
      parentComponent,
      renderers,
      animationMode: true,
      treeutil
    }
  },
  components:{
    QuickAnimate,
    QuickTransformEditComponents
    //ComponentGraphRenderer
  },
  computed:{
    directParent() {
      return this.parents[0];
    },
    hasParents() {
      return !!this.parents.length;
    }
  }
}
</script>
<style>
.quick-edit-components .component-graph-renderer-top {
  transform: scale(0.7);
  @apply -mt-10;
}
</style>
